






import { Component, Vue } from 'vue-property-decorator';
import MapsGenerator from './components/MapsGenerator.vue';

@Component({
  components: {
    MapsGenerator,
  },
})
export default class App extends Vue {}
